import 'script-loader!../../../libs/oms/oms.min.js'



// WEBPACK FOOTER //
// ./public/assets/js/src/vendor/oms.js